import React, { Component } from 'react'
import css from './styleOutline.module.css'

export default class Select extends Component {
    state = {
        error: null
    }

    setError(error) {
        this.setState({
            error
        })
    }

    removeError() {
        this.setState({
            error: null
        })
    }
    
    render() {
        const { style, label, TrailingIcon, className, ...props } = this.props

        const classes = [className]
        classes.push(css.box)

        return (
            <label className={classes.join(' ')} style={{ ...style }}>
                <select
                    {...props}
                    ref="select"
                    className={[css.formControl, this.state.error !== null ? css.error : null].join(' ')}
                    onClick={() => {
                        this.removeError()
                    }} 
                 />
                {label && (
                    <span>{label}</span>
                )}
                <span className={css.arrow} />

                {this.state.error && (
                    <span className={css.errorMessage}>{this.state.error}</span>
                )}
            </label>
        )
    }
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Form/Select.js